<template>
    <v-dialog
        :hide-overlay="true"
        :persistent="true"
        v-model="thresholdModal"
        width="800"
    >
        <v-card class="pt-0">
            <v-app-bar
                flat
                color="rgba(0, 0, 0, 0)"
                style="background: rgb(26, 57, 88)"
            >
                <v-toolbar-title class="text-h6 white--text pl-0">
                    {{ userData.login }}
                    {{ $t("alertHub.nextLevelThresholdChange") }}
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn color="white" icon @click="closeModal"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-app-bar>

            <v-card-actions>
                <v-row>
                    <v-col cols="12" class="pb-2">
                        <table style="width: 100%">
                            <tr style="color: #9e9e9e; font-weight: 700">
                                <td>
                                    {{ $t("common.table.alertType") }}
                                </td>
                                <td style="text-align: center">
                                    {{ $t("alertHub.currentAlertLevel") }}
                                </td>
                                <td style="text-align: right">
                                    {{ $t("alertHub.thresholdMultiplier") }}
                                </td>
                            </tr>
                            <tr
                                v-for="(detail, type) in userData.alert_type"
                                :key="type"
                            >
                                <td>
                                    {{ nameMap[type] }}
                                </td>
                                <td style="text-align: center">
                                    {{ "L" + detail.alert_level }}
                                </td>
                                <td style="text-align: right">
                                    <v-autocomplete
                                        single-line
                                        v-model="
                                            selectedMultiplier[type][
                                                'multiplier'
                                            ]
                                        "
                                        :items="multiplierOptions"
                                        item-text="name"
                                        item-value="value"
                                        hide-details
                                        style="
                                            padding-top: 0;
                                            margin-top: 0;
                                            width: 65%;
                                            margin-left: auto;
                                        "
                                    />
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="3" class="pt-2">
                        <div
                            style="
                                display: flex;
                                align-items: start;
                                height: 100%;
                            "
                        >
                            {{ $t("common.table.lastCommentBy") }}:
                        </div>
                    </v-col>
                    <v-col cols="9" class="pb-0">
                        {{ commentData.last_comment_by }}
                    </v-col>
                    <v-col cols="3" class="pt-2">
                        <div
                            style="
                                display: flex;
                                align-items: start;
                                height: 100%;
                            "
                        >
                            {{ $t("common.table.lastComment") }}:
                        </div>
                    </v-col>
                    <v-col cols="9" class="pb-0">
                        <v-textarea
                            v-model="commentData.last_comment"
                            filled
                            rows="2"
                            readonly
                            hide-details
                        ></v-textarea>
                    </v-col>
                    <v-col cols="3" class="pt-2">
                        <div
                            style="
                                display: flex;
                                align-items: start;
                                height: 100%;
                            "
                        >
                            {{ $t("common.table.lastCommentTime") }}:
                        </div>
                    </v-col>
                    <v-col cols="9" class="pb-0">
                        {{ commentData.last_comment_time }}
                    </v-col>
                    <v-col cols="3" class="pt-2">
                        <div
                            style="
                                display: flex;
                                align-items: start;
                                height: 100%;
                            "
                        >
                            {{ $t("common.table.comment") }}:
                        </div>
                    </v-col>
                    <v-col cols="9" class="pb-0">
                        <v-textarea
                            v-model="comment"
                            filled
                            auto-grow
                            rows="5"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-actions>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click.stop="() => confirmUpdate()"
                    :loading="commentLoading"
                    >{{ $t("common.form.confirm") }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { helper } from "@components/mixins/helper";
import { snackbar } from "@components/mixins/snackbar";
import { updateAlertThreshold, fetchLastComment } from "@services/alert-hub";
import { getBroker } from "@utils/util";
import common from "@assets/js/common.js";

export default {
    props: {
        thresholdModal: false,
        userData: Object,
        closeModal: Function,
        updateModal: Function,
    },
    mixins: [helper, snackbar],
    data() {
        return {
            loading: false,
            selectedMultiplier: {},
            comment: null,
            multiplierOptions: [
                {
                    name: "1.5 (default)",
                    value: 1.5,
                },
                {
                    name: "2",
                    value: 2,
                },
                {
                    name: "3",
                    value: 3,
                },
            ],
            nameMap: {
                MSG_TYPE_MONITOR_FAST_CLOSED_TRADE: "Fast Close",
                MSG_TYPE_MONITOR_HIGH_VOLUME_USD: "High Volume USD",
                MSG_TYPE_MONITOR_HIGH_TRADE_COUNT: "High Trades",
                MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL: "Large PNL",
                // Large_Exposure: "Large_Exposure",
                // Cross_Account_Hedging: "Cross_Account_Hedging",
                MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE:
                    "Low Liquidity Arbitrage",
                // New_Deposit: "New_Deposit",
                // New_Trade: "New_Trade",
            },
            commentData: {},
            commentLoading: false,
        };
    },
    watch: {
        thresholdModal(nv) {
            if (nv) {
                this.comment = this.userData.comment;
                this.selectedMultiplier = Object.keys(
                    this.userData.alert_type
                ).reduce((acc, type) => {
                    acc[type] = {
                        multiplier: 1.5,
                        id: this.userData.alert_type[type].id,
                    };
                    return acc;
                }, {});
                this.commentLoading = true;
                this.getLastComment();
            } else {
                this.commentData = {};
                this.commentLoading = false;
            }
        },
    },
    methods: {
        getLastComment() {
            fetchLastComment({
                login: this.userData.login,
                server_id: this.userData.server_id,
            })
                .then((res) => {
                    this.commentData = res.data;
                })
                .catch(() => {
                    this.commentData = {
                        last_comment: "",
                        last_comment_by: "",
                        last_comment_time: "",
                    };
                })
                .finally(() => {
                    this.commentLoading = false;
                });
        },
        confirmUpdate() {
            if (!this.selectedMultiplier) {
                this.snackBarDanger(this.$t("alertHub.noThresholdWarning"));
                return;
            }
            this.commentLoading = true;
            const params = {
                multiplier: this.selectedMultiplier,
                comment: this.comment ?? "",
                login: getBroker() + ":" + this.userData.fullLoginInfo,
                date: common.getMT4TimeString().split(" ")[0],
                comment_by: localStorage.getItem("user_id"),
            };
            // console.log("params", params);
            updateAlertThreshold(params)
                .then((res) => {
                    this.snackBarSuccess(res.data.msg);
                    this.updateModal();
                })
                .finally(() => {
                    this.commentLoading = false;
                });
        },
    },
};
</script>
